import Dictionary from '@utils/classes/dictionary';

export const STATUS = {
  1: 'single',
  2: 'married',
  3: 'divorced',
  4: 'separated',
  5: 'widowed',
  6: 'in_relationship',
  7: 'engaged',
  8: 'in_complicated_relationship',
  9: 'in_open_relationship',
};

export const maritalStatus = new Dictionary(STATUS);
